import styled from 'styled-components';
export const ModalHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 12px;
`;
export const ModalTitleIcon = styled.div `
  font-size: 20px;
`;
export const ModalFooter = styled.div `
  display: flex;
  margin-top: 25px;
  justify-content: space-between;

  @media (max-width: 360px) {
    flex-wrap: wrap;
  }
`;
export const ModalTitle = styled.span `
  padding-left: 8px;
  font-size: 20px;
  font-weight: 600;
  line-height: normal;
`;
export const ModalText = styled.div `
  font-size: 14px;
  font-weight: normal;
`;
export const ModalTextQuestion = styled.div `
  margin-top: 10px;
`;
export const ButtonWrapper = styled.div `
  margin-bottom: 5px;
  width: 100%;
  display: flex;
  gap: 10px;
  & > button {
    width: 50%;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    display: block;
    & > button {
      width: 100%;
      &:last-child {
        margin-top: 1rem;
      }
    }
  }
`;
//# sourceMappingURL=ConfirmationModal.styled.js.map